export type Carrier =
  | "mci"
  | "taliya"
  | "irancell"
  | "rightel"
  | "shatel"
  | "aptel"
  | "fanap"
  | "samantel"
  | "other_carrier";

export const getCarrierByPhoneNumber = (phoneNumber: string): Carrier => {
  let digitsOnly = phoneNumber.replaceAll(/\D/g, "");

  if (digitsOnly.startsWith("+98")) {
    digitsOnly = digitsOnly.slice(3);
  } else if (digitsOnly.startsWith("0098")) {
    digitsOnly = digitsOnly.slice(4);
  }

  if (digitsOnly.startsWith("0")) {
    digitsOnly = digitsOnly.slice(1);
  }

  digitsOnly = `0${digitsOnly}`;

  const prefix4 = digitsOnly.slice(0, 4);
  const prefix5 = digitsOnly.slice(0, 5);

  // Samantel (5-digit prefix)
  if (prefix5 === "09999") return "samantel";

  // Fanap (5-digit prefix)
  if (prefix5 === "09991") return "fanap";

  // MCI: 0910, 0911–0919, 0990–0996
  if (
    prefix4 === "0910" ||
    (prefix4 >= "0911" && prefix4 <= "0919") ||
    (prefix4 >= "0990" && prefix4 <= "0996")
  ) {
    return "mci";
  }

  // Taliya
  if (prefix4 === "0932") return "taliya";

  // Irancell: 0930–0939, 0900–0905
  if (
    (prefix4 >= "0930" && prefix4 <= "0939") ||
    (prefix4 >= "0900" && prefix4 <= "0905")
  ) {
    return "irancell";
  }

  // Rightel: 0920–0923
  if (prefix4 >= "0920" && prefix4 <= "0923") return "rightel";

  // Shatel
  if (prefix4 === "0998") return "shatel";

  // Aptel
  if (prefix4 === "0999") return "aptel";

  // Default fallback
  return "other_carrier";
};
